import { forwardRef } from 'react';
import { ListBoxItemRenderProps } from 'react-aria-components';
import { IconCheck } from '@maia/icons';
import { StatusIcon } from '../../../atoms/statusIcon/statusIcon';
import { StatusIconStylesVariants } from '../../../atoms/statusIcon/variants';
import { Typography } from '../../../ui';

type Props = {
  label: string;
  status: {
    color: StatusIconStylesVariants['color'];
    variant: StatusIconStylesVariants['variant'];
  };
  className?: string;
} & Partial<ListBoxItemRenderProps>;

export const DropdownOptionStatus = forwardRef<HTMLDivElement, Props>(
  ({ label, status, isSelected, isFocusVisible }, ref) => {
    return (
      <div
        className="flex flex-row items-center space-x-8 rounded-4 py-8 px-12 hover:bg-primary50"
        ref={ref}
      >
        <StatusIcon {...status} />

        <Typography
          variant="body-xs"
          weight={isSelected || isFocusVisible ? 'medium' : 'regular'}
          className="flex-1 text-grayscale600"
        >
          {label}
        </Typography>

        {isSelected && (
          <IconCheck className="min-w-16 w-16 h-16 ml-8 fill-grayscale600" />
        )}
      </div>
    );
  },
);

DropdownOptionStatus.displayName = 'DropdownOptionStatus';
